export default "__VITE_ASSET__MuTHpKPS__"